/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type WebhookDataWalletCreated = {
  accountID: string;
  walletID: string;
};

/** @internal */
export const WebhookDataWalletCreated$inboundSchema: z.ZodType<
  WebhookDataWalletCreated,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  walletID: z.string(),
});
/** @internal */
export type WebhookDataWalletCreated$Outbound = {
  accountID: string;
  walletID: string;
};

/** @internal */
export const WebhookDataWalletCreated$outboundSchema: z.ZodType<
  WebhookDataWalletCreated$Outbound,
  z.ZodTypeDef,
  WebhookDataWalletCreated
> = z.object({
  accountID: z.string(),
  walletID: z.string(),
});

export function webhookDataWalletCreatedToJSON(
  webhookDataWalletCreated: WebhookDataWalletCreated,
): string {
  return JSON.stringify(
    WebhookDataWalletCreated$outboundSchema.parse(webhookDataWalletCreated),
  );
}
export function webhookDataWalletCreatedFromJSON(
  jsonString: string,
): SafeParseResult<WebhookDataWalletCreated, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WebhookDataWalletCreated$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WebhookDataWalletCreated' from JSON`,
  );
}
